
import { defineComponent } from "vue";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import ClassicButton from "@/components/ClassicButton.vue";

export default defineComponent({
  name: "Home",
  components: {
    ClassicButton,
    HelloWorld,
  },
});
